import { render, staticRenderFns } from "./ManageSubjectDetail.vue?vue&type=template&id=8585b720&"
import script from "./ManageSubjectDetail.vue?vue&type=script&lang=js&"
export * from "./ManageSubjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./ManageSubjectDetail.vue?vue&type=style&index=0&id=8585b720&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports